import axios from "axios";

export default {
  state: {
    allVacansii: [],
    vakansija: [],
    load: false,
    emptysearch: false
  },
  mutations: {
    LOAD(state, how) {
      state.load = how;
    },

    UPDATE_VAKANS(state, bageVakans) {
      state.allVacansii = bageVakans;

      // const bageVakans = addClassToBage(vakans);
      // state.allVacansii = bageVakans;
    },
    UPDATE_ONE_VAKANSIJA(state, vakansija) {
      state.vakansija = vakansija;
      state.load = false;
    },
    FILTERED_VAKANS_BY_SEARCH(state, search) {
      let countSearch = 0;
      state.allVacansii.map(function(item) {
        if (
          item.headerVakans.toLowerCase().indexOf(search.toLowerCase()) != "-1"
        ) {
          item.isVisiblVak = true;
          countSearch++;
        } else item.isVisiblVak = false;
      });
      state.load = false;
      if (countSearch == 0) {
        state.emptysearch = true;
      } else state.emptysearch = false;

      // if (!this.sortedVakans.length && inside.search.text) {
      //   this.emptysearch = true;
      //   console.log(this.sortedVakans);
      // } else this.emptysearch = false;
    },
    FILTERED_VAKANS_BY_CATEGORY(state, kategoryes) {
      state.load = true;

      state.allVacansii.map(function(item) {
        let categoryCheckCount = 0;
        for (let i = 0; i < kategoryes.length; i++) {
          if (item.kategory.indexOf(kategoryes[i]) != -1) {
            categoryCheckCount++;
          } else break;
        }

        if (categoryCheckCount != kategoryes.length) {
          item.isVisiblVak = false;
        } else item.isVisiblVak = true;
      });

      state.load = false;
      if (state.allVacansii.length == 0) {
        state.emptysearch = true;
      } else state.emptysearch = false;
    }
  },
  actions: {
    SEARCH_VAKANS({ commit }, search) {
      commit("LOAD", true);
      commit("FILTERED_VAKANS_BY_SEARCH", search);
    },

    GET_VAKANS_FROM_API({ state, commit }, kategoryes) {
      commit("LOAD", true);
      if (!state.allVacansii.length) {
        return axios(
          "https://api.partners.fenek.fun/readVakans/readVakans.php",
          {
            // return axios("http://teeal.parser/readVakans/readVakans.php", {
            method: "GET"
          }
        )
          .then(vakans => {
            const bageVakans = addClassToBage(vakans.data);
            commit("UPDATE_VAKANS", bageVakans);
            // return vakans.data;
          })
          .then(vakans => {
            commit("FILTERED_VAKANS_BY_CATEGORY", kategoryes);
          })
          .catch(error => {
            console.log(error);
            return error;
          });
      } else {
        commit("FILTERED_VAKANS_BY_CATEGORY", kategoryes);
      }
    },
    GET_ONE_VAKANSIJA_FROM_API({ commit }, idVakans) {
      commit("LOAD", true);
      return axios(
        `https://api.partners.fenek.fun/readVakans/readVakansija.php/?idVakans=${idVakans}`,
        {
          method: "GET"
        }
      )
        .then(vakansija => {
          const bageVakansija = addClassToBage([vakansija.data]);
          commit("UPDATE_ONE_VAKANSIJA", bageVakansija[0]);
          //return vakansija.data;
        })
        .catch(error => {
          console.log(error);
          return error;
        });
    }
  },
  getters: {
    VACANSII(state) {
      return state.allVacansii;
      // if (state.filterdVacansii) return state.filterdVacansii;
      // else return state.allVacansii;
    },
    ONE_VACANSIJA(state) {
      return state.vakansija;
    },
    ISLOAD(state) {
      return state.load;
    },
    GET_EMPTY_SEARCH(state) {
      return state.emptysearch;
    }
  }
};

function addClassToBage(vakans) {
  for (let i = 0; i < vakans.length; i++) {
    if (vakans[i].kategory.indexOf("Вакансии по безвизу") === -1) {
      vakans[i].isBezviz = "viza";
    }
    if (vakans[i].kategory.indexOf("Вакансии по UA контракту") === -1) {
      vakans[i].isUa = "neUa";
    }
    if (vakans[i].kategory.indexOf("Актуальные вакансии") === -1) {
      vakans[i].isActual = "neActual";
    }
  }
  return vakans;
}
